module.exports = __webpack_public_path__ + "static/media/rm_06-19.5dc192bf.png";